<template>
  <q-btn
    :data-testid="dataTestid"
    :label="label"
    icon-right="mdi-plus-thick"
    :disable="disabled"
    align="left"
    :color="$q.dark.isActive ? 'green-7' : 'green-4'"
    @click="emit('click')"
  />
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    label: string;
    dataTestid: string;
    disabled?: boolean;
  }>(),
  {},
);

const emit = defineEmits(['click']);
</script>
<style scoped lang="scss">
:deep(span) {
  color: #1d1d1d;
  font-weight: bold;
}
</style>
